export const SCORE_RANGE_STEP = 100
export const MAX_POSSIBLE_SCORE = 1000
export const MIN_POSSIBLE_SCORE = 0
export const DEFAULT_PAGE_INDEX = 0
export const DEFAULT_PAGE_SIZE = 10
